import { render, staticRenderFns } from "./payoutHistory.vue?vue&type=template&id=22124976"
import script from "./payoutHistory.vue?vue&type=script&lang=js"
export * from "./payoutHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports